"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultCurrencyFormat = void 0;
/**
 * The default currency format configuration for positive, negative and zero patterns.
 * Examples: pos: $123,456.78, neg: -$123,456.78, zero: $0.00
 */
exports.defaultCurrencyFormat = {
    pos: '%s%v',
    neg: '-%s%v',
    zero: '%s%v'
};
//# sourceMappingURL=currency-format.js.map